import { useContext } from "react";
import { GlobalContext } from "../../../GlobalContext";
import { useLocation } from "react-router";
import useAzureAuthenticate from "./useAzureAuthenticate";
import useHandleAzureSignupHint from "./useHandleAzureSignupHint";

/**
 * Attach azure marketplace info to an organization
 * @returns {(authenticationResult: AuthenticationResult) => Promise<void>}
 */
function useAttachAzureSaasToOrganization() {
  const { auth } = useContext(GlobalContext);
  const handleHint = useHandleAzureSignupHint();
  const location = useLocation();

  return useAzureAuthenticate(
    (org) => {
      return auth.attachAzureSaas(new URLSearchParams(location.search).get("token")).then(() => console.log(org));
    },
    (authObject, error) => handleHint(authObject, error.response.body)
  );
}

export default useAttachAzureSaasToOrganization;
